<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon">close</mat-icon>
</button>
<h1 mat-dialog-title align="center">Configuración</h1>
<mat-progress-bar *ngIf="categoriesAdd == null || layersAdd == null || formsAdd == null || usersAdd == null"
  mode="indeterminate">
</mat-progress-bar>
<mat-tab-group mat-align-tabs="center" (selectedIndexChange)="changeTab($event)" mat-dialog-content>
  <mat-tab label="Espacio de Trabajo">
    <mat-accordion class="content-settings">
      <mat-expansion-panel *ngFor="let category of categoriesAdd">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{category.categoria_capa_nombre}}
            <mat-icon matTooltip="Editar Nombre de Categoria" class="button-layer"
              (click)="editCategory(category.categoria_capa_id)" color="primary">edit</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-accordion>
          <ng-container *ngFor="let layer of layersAdd">
            <mat-expansion-panel *ngIf="layer.categoria_capa_id==category.categoria_capa_id" >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{layer.capa_nombre}}
                  <div>
                    <mat-icon matTooltip="Editar Capa" (click)="editLayer(layer.capa_id)" color="primary">create
                    </mat-icon>
                    <mat-icon matTooltip="Eliminar esta Capa" class="button-layer colorRed"
                      (click)="deleteLayer(layer.capa_id)">delete</mat-icon>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <mat-list>
                <ng-container *ngFor="let form of formsAdd">
                  <mat-list-item *ngIf="form.capa_id==layer.capa_id">
                    {{form.formulario_nombre}}
                    <div>
                      <mat-icon matTooltip="Ver o agregar campos del Formulario" class="button-layer"
                        (click)="editForm(form.formulario_Id)" color="primary">create</mat-icon>
                      <mat-icon matTooltip="Eliminar este Formulario" class="button-layer colorRed"
                        (click)="deleteForm(form.formulario_Id)">delete</mat-icon>
                    </div>
                  </mat-list-item>
                </ng-container>
              </mat-list>
            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-tab>

  <mat-tab label="Gestión de Usuarios">
      <mat-accordion>
      <mat-expansion-panel *ngFor="let user of usersAdd">
       <mat-expansion-panel-header>
          <mat-panel-title>
            {{user.usuario_realgisNombre1}} {{user.usuario_realgisApellido1}}
            <mat-icon>account_circle</mat-icon>
          </mat-panel-title>
          
        </mat-expansion-panel-header>
        <b>Nombres:</b> {{user.usuario_realgisNombre1}} {{user.usuario_realgisNombre2}} <br>
        <b>Apellidos:</b> {{user.usuario_realgisApellido1}} {{user.usuario_realgisApellido2}}<br>
        <b>Rol:</b> {{user.Rol_Nombre}}<br>
        <b>Correo:</b> {{user.usuario_realgisCorreo}}<br>
        <b>Identificación:</b> {{user.usuario_realgisTipo}} {{user.usuario_realgisDoc}}<br>
        <b>Usuario:</b> {{user.usuario_realgisUsuario}}<br>
        <mat-action-row>
           <mat-icon matTooltip="Ver formularios asignados" class="button-layer"
           (click)="getFormsUser(user.usuario_realgisId)" color="primary" *ngIf="user.Rol_Nombre == 'Consulta' || user.Rol_Nombre == 'Reconocedor'">assignment_ind</mat-icon>
          <mat-icon matTooltip="Editar usuario" class="button-layer" (click)="openEditUser(user.usuario_realgisId)"
            color="primary">create</mat-icon>
          <mat-icon matTooltip="Inhabilitar usuario" class="button-layer colorRed"
            (click)="disableUser(user.usuario_realgisId , user.usuario_realgisNombre1 , user.usuario_realgisApellido1)">person_remove</mat-icon>
        </mat-action-row>
       
        
        
      </mat-expansion-panel>
    </mat-accordion>
  </mat-tab>

</mat-tab-group>

<div mat-dialog-actions *ngIf="indexTab == 0">
  <button mat-raised-button matTooltip="Crear una nueva Categoria" (click)="createCategory()">

    <mat-icon>category</mat-icon>
    <sup>
      <mat-icon>add</mat-icon>
    </sup>
  </button>
  <button mat-raised-button matTooltip="Crear una nueva Capa" (click)="createLayer()">
    <mat-icon>layers</mat-icon>
    <sup>
      <mat-icon>add</mat-icon>
    </sup>
  </button>
  <button mat-raised-button matTooltip="Crear un nuevo formulario" (click)="createForm()">
    <mat-icon>assignment</mat-icon>
    <sup>
      <mat-icon>add</mat-icon>
    </sup>
  </button>
</div>

<div mat-dialog-actions *ngIf="indexTab == 1">
  <button mat-raised-button matTooltip="Crear un nuevo Usuario" (click)="openCreateUser()">
    <mat-icon>person_add</mat-icon>
  </button>
</div>